import { axiosMediaPrivate } from "../../../api/axios";
import { FilePreviewIdentifier } from "../../../types/types";
import { FilePreviewDescriptor, FilePreviewFile } from "../types";
import {
  buildFilePreviewFile,
  buildFileDownloadUrl,
  toFilePreviewDescriptor,
  normalizeFilePreviewFile,
} from "../utils/filePreview";
import {
  createPreviewNotFoundError,
  normalizePreviewApiError,
  PREVIEW_NOT_FOUND_MESSAGE,
} from "../utils/previewError";

function createRequestConfig(signal?: AbortSignal) {
  const token = localStorage.getItem("accessToken");
  const headers = {
    ...(token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {}),
  };

  return {
    responseType: "blob" as const,
    signal,
    headers: Object.keys(headers).length ? headers : undefined,
  };
}

export async function fetchFilePreviewFile(
  fileId: FilePreviewIdentifier,
  signal?: AbortSignal,
  fileName?: string | null,
): Promise<FilePreviewFile> {
  const normalizedFileId = String(fileId).trim();
  if (!normalizedFileId) {
    throw createPreviewNotFoundError();
  }

  try {
    const response = await axiosMediaPrivate.get(
      buildFileDownloadUrl(normalizedFileId, fileName),
      createRequestConfig(signal),
    );

    return await normalizeFilePreviewFile(
      buildFilePreviewFile({
        fileId: normalizedFileId,
        blob: response.data,
        headers: response.headers,
      }),
    );
  } catch (error) {
    throw await normalizePreviewApiError(error, PREVIEW_NOT_FOUND_MESSAGE);
  }
}

export async function probeFilePreviewDescriptor(
  fileId: FilePreviewIdentifier,
  signal?: AbortSignal,
  fileName?: string | null,
): Promise<FilePreviewDescriptor> {
  const normalizedFileId = String(fileId).trim();
  if (!normalizedFileId) {
    throw createPreviewNotFoundError();
  }

  try {
    const response = await axiosMediaPrivate.get(
      buildFileDownloadUrl(normalizedFileId, fileName),
      createRequestConfig(signal),
    );

    const previewFile = await normalizeFilePreviewFile(
      buildFilePreviewFile({
        fileId: normalizedFileId,
        blob: response.data,
        headers: response.headers,
      }),
    );

    return toFilePreviewDescriptor(previewFile);
  } catch (error) {
    throw await normalizePreviewApiError(error, PREVIEW_NOT_FOUND_MESSAGE);
  }
}
